import React from 'react';
import { List } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { sortedApproversByEmail } from '../../helper';
import RequestApproversList from '../components/RequestApproversList';
import { resolveRequestWorkflow } from '../../state/state';

const RequestDatasetOwnersListItem = ({ owners }) => {
  if (owners.length === 0) {
    return null;
  }

  return (
    <List.Item className="aridhia-request-dataset-owners-list-item">
      <List.Header>
        <FormattedMessage id="request.list.dataset.owners.title" />
      </List.Header>
      <RequestApproversList items={owners} className="pt-0" />
    </List.Item>
  );
};

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps, { datasets: [] });
  const approvers = sortedApproversByEmail(request);

  return {
    owners: approvers,
  };
};

export default connect(mapStateToProps)(RequestDatasetOwnersListItem);
